export default function getDocumentName(): string | null {
  const node = document.querySelector<HTMLInputElement>('.js-document-name');

  if (node && node.value) {
    console.log(node.value);
    return node.value;
  }

  return null;
}
